import { MoveGenerator } from '../../jscaip/AI/AI';
import { QuixoMove } from './QuixoMove';
import { QuixoRules } from './QuixoRules';
export class QuixoMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const moves = [];
        const verticalCoords = QuixoRules.getVerticalCoords(node);
        const horizontalCenterCoords = QuixoRules.getHorizontalCenterCoords(node);
        const coords = horizontalCenterCoords.concat(verticalCoords);
        for (const coord of coords) {
            const possibleDirections = QuixoRules.get().getPossibleDirections(state, coord);
            for (const possibleDirection of possibleDirections) {
                const newMove = new QuixoMove(coord.x, coord.y, possibleDirection);
                moves.push(newMove);
            }
        }
        return moves;
    }
}
